const btnClearFilterExpiredServices = {
  Typography: 'Limpar'
};

export default btnClearFilterExpiredServices;
